import { FC, Fragment } from "react";
import { useFlag } from "@unleash/proxy-client-react";
import { BillingData } from "./pages/common/billing/billing-data/BillingData";
import { useRefreshTokenHook } from "./utils/hooks/useRefreshTokenHook";
import { CleanV2FAB } from "./pages/common/clean-v2/CleanV2FAB";
import { TaskCreationDrawer } from "./pages/common/task-management/TaskCreationDrawer";
import { useInitiateHiddenResourceTypesByFeatureToggle } from "./pages/live-usage-mgmt/utils/hooks/useInitiateHiddenResourceTypesByFeatureToggle.hook";
import { ShowCelebrationPopupWrapper } from "./celebration-popup/ShowCelebrationPopupWrapper";
import { AskAi } from "./pages/common/ask-ai/AskAi";
import { ResourceGridCleanComponents } from "@/components/pages/common/resources-ag-grid/components/resource-clean/ResourceGridCleanComponents";
import { BudgetDetailsDrawer } from "@/components/pages/budgets-and-alerts/components/drawer/budget-details-drawer/BudgetDetailsDrawer";
import { BudgetsAndAlertsEditorDrawer } from "@/components/pages/budgets-and-alerts/components/drawer/budget-alert-create-edit-drawer/BudgetsAndAlertsEditorDrawer";

export const Common: FC = () => {
  const enableAskAi = useFlag("EnableAskAi");

  useRefreshTokenHook();
  useInitiateHiddenResourceTypesByFeatureToggle();

  return (
    <Fragment>
      <CleanV2FAB />
      <ResourceGridCleanComponents />

      <BillingData />
      <TaskCreationDrawer />
      <ShowCelebrationPopupWrapper />

      {/*Budgets*/}
      <BudgetDetailsDrawer />
      <BudgetsAndAlertsEditorDrawer />

      {enableAskAi && <AskAi />}
    </Fragment>
  );
};
